import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Terms of Use placeholder page.
 * Required for Microsoft Teams app manifest.
 */
export const TermsPage: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
        Terms of Use
      </h1>

      <div className="prose dark:prose-invert max-w-none">
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          <strong>Last updated:</strong> {new Date().toLocaleDateString()}
        </p>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-4">
          Acceptance of Terms
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          By accessing and using Client Dashboards, you accept and agree to be bound
          by these Terms of Use.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-4">
          Use of Service
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          This application is provided for internal business analytics purposes. You agree
          to use it only for its intended purpose of analyzing advertising campaign data.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-4">
          Data Responsibility
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          You are responsible for ensuring that any data you upload complies with your
          organization's data handling policies and applicable regulations.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-4">
          Disclaimer
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          The analytics and AI-generated insights provided by this application are for
          informational purposes only. Decisions made based on this data are your responsibility.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-4">
          Modifications
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          We reserve the right to modify these terms at any time. Continued use of the
          service constitutes acceptance of updated terms.
        </p>
      </div>

      <div className="mt-12">
        <Link
          to="/upload"
          className="text-indigo-600 dark:text-indigo-400 hover:underline"
        >
          &larr; Back to Dashboard
        </Link>
      </div>
    </div>
  );
};
